<div class="row mt-4 requestType">
  <div class="col-sm-12">
    <h1 class="text-primary mb-4">{{'WorkflowCreatePM.PreStage.CardValidacaoDadosFalecido.Title' | translate}}</h1>
  </div>
  <!--Numero de utente-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="numeroDeUtente">
        {{'WorkflowCreatePM.PreStage.CardValidacaoDadosFalecido.NumeroDeUtente' | translate}}
      </label>
      <input class="form-control" type="number"
             [(ngModel)]="model.subscriberNumber"
             name="subscriberNumber"
             [disabled]="isAtendimento"
             #subscriberNumber="ngModel"
             numeric="7"
             required>
      <validation-message [control]="subscriberNumber" ></validation-message>
    </div>
  </div>
  <!--Numero de identificaçãp Fiscal-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="nif">
        {{'WorkflowCreatePM.PreStage.CardValidacaoDadosFalecido.NIF' | translate}}
      </label>
      <input class="form-control" type="number"
             [(ngModel)]="model.NIF" name="nif"
             #nif="ngModel"
             numeric="9"
             nifValidation
             [disabled]="isAtendimento"
             required>
      <validation-message [control]="nif" ></validation-message>
    </div>
  </div>


</div>
